import { Controller } from "react-hook-form";
import CustomTooltip from "../ui-components/tooltip";
import { Info } from "lucide-react";
// ** Third Party
import Proptypes from "prop-types";
import classnames from "classnames";

const SwitchField = (props) => {
  const {
    label,
    name,
    disabled = false,
    control,
    className = "",
    customOnChange = () => {},
    desc = "",
    tooltipContent = "",
    id
  } = props;
  return (
    <div
      className={classnames("flex items-center p-0", {
        [className]: className
      })}
    >
      {label && (
        <label htmlFor={name} className="mb-0 mr-1" data-cy={`label-${id}`}>
          {label}
          {Boolean(tooltipContent) && (
            <>
              <Info size={16} className="ml-1 cursor-pointer text-secondary" />
              <CustomTooltip
                target={`tooltip-${id}`}
                content={tooltipContent}
              />
            </>
          )}
        </label>
      )}
      <Controller
        name={name}
        control={control}
        render={({ field: { onChange, value } }) => {
          const checked = Boolean(value) || false;
          return (
            <label
              htmlFor={name}
              className={classnames(
                "relative inline-flex h-5 w-9 shrink-0 cursor-pointer items-center rounded-full transition-colors",
                checked ? "bg-primary" : "bg-gray-300",
                { "cursor-not-allowed opacity-50": disabled }
              )}
            >
              <input
                onChange={(e) => {
                  if (customOnChange) {
                    customOnChange(e.target.checked);
                  }
                  onChange(e);
                }}
                data-cy={`switch-${name}`}
                type="checkbox"
                role="switch"
                className="sr-only"
                checked={checked}
                id={name}
                disabled={disabled}
              />
              <span
                className={classnames(
                  "inline-block h-4 w-4 transform rounded-full bg-white transition-transform",
                  checked ? "translate-x-4" : "translate-x-0.5"
                )}
              />
            </label>
          );
        }}
      />
      <br />
      {desc && (
        <small className="font-bold">
          <i>{desc}</i>
        </small>
      )}
    </div>
  );
};

export default SwitchField;

SwitchField.propTypes = {
  label (props, propName) {
    // ** If label is defined and htmlFor is undefined throw error
    if (props[propName] && props["htmlFor"] === "undefined") {
      throw new Error("htmlFor prop is required when label prop is present");
    }
  },
  id            : Proptypes.string,
  name          : Proptypes.string.isRequired,
  serverErrors  : Proptypes.shape({}),
  disabled      : Proptypes.bool,
  control       : Proptypes.any.isRequired,
  className     : Proptypes.string,
  desc          : Proptypes.string,
  tooltipContent: Proptypes.string,
  customOnChange: Proptypes.func
};
